<template>
    <!-- with shipping address and shipping options -->
    <!-- <google-pay-button
        class="google-pay-button"
        style="width: 100%; height: 64px;"
      
        :button-type="buttonType"
        :button-color="buttonColor"
        :button-radius="buttonRadius"
        :button-locale="buttonLocale"
        :button-size-mode="buttonSizeMode"

        :existing-payment-method-required="existingPaymentMethodRequired"
      
        environment="TEST"
      
        :payment-request.prop="paymentRequest"

        @cancel="onCancelCallback"
        :click-callback.prop="onClickCallback"
        @error="onErrorCallback"
        @loadpaymentdata="onLoadPaymentDataCallback"
        :on-payment-data-changed.prop="onPaymentDataChanged"
        :on-payment-authorized.prop="onPaymenAuthorized"
        @readytopaychange="onReadyToPayChangeCallback"
    /> -->

    <!-- without shipping address and shipping options -->
    <google-pay-button
        class="google-pay-button"
        style="height: 48px;"


        :button-type="buttonType"
        :button-color="buttonColor"
        :button-radius="buttonRadius"
        :button-locale="buttonLocale"
        :button-size-mode="buttonSizeMode"
      
        :environment="environment"
      
        :payment-request.prop="paymentRequest"

        @cancel="onCancelCallback"
        :click-callback.prop="onClickCallback"
        @error="onErrorCallback"
        @loadpaymentdata="onLoadPaymentDataCallback"
        @readytopaychange="onReadyToPayChangeCallback"
    />
</template>

<script>
    import '@google-pay/button-element';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            buttonColor: {
                type: String,
                default: 'black',
            },
            buttonLocale: {
                type: String,
                default: 'pt',
            },
            buttonRadius: {
                type: String,
                default: '8',
            },
            buttonSizeMode: {
                type: String,
                default: 'fill',
            },
            buttonType: {
                type: String,
                default: 'checkout', // TODO: Valor 'checkout' precisa voltar pra 'pay' quando a google resolver o problema com a bandeira ELO
            },
            onGPCancel: {
                type: Function,
                default: null,
            },
            onGPClick: {
                type: Function,
                default: null,
            },
            onGPError: {
                type: Function,
                default: null,
            },
            onGPLoadPaymentData: {
                type: Function,
                default: null,
            },
            onGPPaymenAuthorized: {
              type: Function,
              default: null,
            },
            onGPPaymentDataChanged: {
                type: Function,
                default: null,
            },
            onGPReadyToPayChange: {
                type: Function,
                default: null,
            }
        },

        computed: {
            ...mapGetters({
                paymentRequest: 'googlePayPayment/getPaymentRequest',
                environment: 'googlePayPayment/getEnvironment',
            }),
        },
        
        methods: {

          /**
           * Dispara quando o modal é fechado clicando em cancelar
           */
          onCancelCallback() {
              if (this.onGPCancel && typeof this.onGPCancel === 'function') {
                  this.onGPCancel();
              }
          },

          /**
           * Dispara assim que o botão é clicado
           */
          onClickCallback() {
              if (this.onGPClick && typeof this.onGPClick === 'function') {
                  this.onGPClick();
              }
          },

          /**
           * Dispara quando temos algum erro no modal/botão
           */
          onErrorCallback(data) {
              if (this.onGPError && typeof this.onGPError === 'function') {
                  this.onGPError(data);
              }
          },

          /**
           * Dispara assim que clicamos em continuar, retornando os dados de pagamento
           */
          onLoadPaymentDataCallback(data) {
              this.$store.commit('googlePayPayment/setFromPaymentData', data.detail);

              if (this.onGPLoadPaymentData && typeof this.onGPLoadPaymentData === 'function') {
                  this.onGPLoadPaymentData(data);
              }

          },

          /**
           * Uso opcional (Atualmente não é usado) - Dispara assim que o pagamento é autorizado ou não,
           * sendo usado pra fazer pré autorizações validando o cartão e se o mesmo tem saldo
           */
          onPaymenAuthorized(data) {
              if (this.onGPPaymenAuthorized && typeof this.onGPPaymenAuthorized === 'function') {
                  this.onGPPaymenAuthorized(data);
              }

              return {
                  transactionState: 'SUCCESS',
              };
          },

          /**
           * Uso opcional (Atualmente não é usado) - Dispara assim que as informações de callbacks settadas são atualizadas
           */
          onPaymentDataChanged(data) {
              switch (data.callbackTrigger) {
                  case 'INITIALIZE':
                      //não consegui fazer pois não tenho um exemplo de como é um retorno com contas vazias
                      break;
                  case 'SHIPPING_ADDRESS':
                      this.$store.dispatch('googlePayPayment/setShippingAddress', data.shippingAddress);
                      break;
                  case 'SHIPPING_OPTION':
                      this.$store.dispatch('googlePayPayment/setShippingOption', data.shippingOptionData);
                      break;
              }

            
              if (this.onGPPaymentDataChanged && typeof this.onGPPaymentDataChanged === 'function') {
                  this.onGPPaymentDataChanged(data);
              }
          },

          /**
           * Dispara assim que é atualizado algum estado dentro do botão
           */
          onReadyToPayChangeCallback(data) {

            this.$store.commit('googlePayPayment/setIsReadyToPay', data.detail.isReadyToPay);

            if (this.onGPReadyToPayChange && typeof this.onGPReadyToPayChange === 'function') {
                this.onGPReadyToPayChange(data);
            }
          },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>